module.exports = __webpack_public_path__ + "img/PMS_MZ_3.44cb09d3.gif";